import Header from '@/pages/home/components/Header';
import Footer from '@/pages/home/components/Footer';
import PresentationHero from './components/PresentationHero';
import PresentationBrochure from './components/PresentationBrochure';
import PresentationAbout from './components/PresentationAbout';
import PresentationServices from './components/PresentationServices';
import PresentationCTA from './components/PresentationCTA';
import SEOHead from '@/components/feature/SEOHead';

const presentationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'CasaReNovaPlus',
  url: `${import.meta.env.VITE_SITE_URL}`,
  logo: `${import.meta.env.VITE_SITE_URL}/favicon.ico`,
  description: 'Entreprise de rénovation à Neuenegg : tous types de travaux de rénovation, électricité, plomberie, chauffage, ventilation, domotique, maintenance 24/7.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Austrasse 95',
    addressLocality: 'Neuenegg',
    postalCode: '3176',
    addressCountry: 'CH',
  },
  telephone: '+41797616282',
  email: 'info@casarenovaplus.ch',
  areaServed: 'Neuenegg, Fribourg, Suisse romande',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Prestations HB SERVICES',
    itemListElement: [
      { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'Électricité NIBT/OIBT Genève' } },
      { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'Sanitaire & Plomberie Genève' } },
      { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'Pompes à chaleur Genève' } },
      { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'Ventilation VMC Genève' } },
      { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'Domotique KNX Genève' } },
      { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'Maintenance urgence 24/7 Genève' } },
      { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'Nettoyage & Conciergerie Genève' } },
      { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'Aide à domicile Genève' } },
    ],
  },
};

export default function Presentation() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="CasaReNovaPlus Neuenegg — Présentation & Plaquette | Rénovation Tous Travaux Suisse"
        description="Découvrez CasaReNovaPlus Neuenegg : plaquette de présentation complète, tous types de travaux de rénovation, électricité, sanitaire, pompes à chaleur, ventilation, domotique, maintenance 24/7. 19 ans d'expérience. Devis gratuit."
        keywords="CasaReNovaPlus Neuenegg, présentation entreprise, plaquette PDF, rénovation Fribourg, CVSE Neuenegg, entreprise générale Suisse romande"
        canonical={`${import.meta.env.VITE_SITE_URL}/presentation`}
        schema={presentationSchema}
      />
      <Header />
      <main className="pt-[88px]">
        <PresentationHero />
        <PresentationBrochure />
        <PresentationAbout />
        <PresentationServices />
        <PresentationCTA />
      </main>
      <Footer />
    </div>
  );
}
